module.exports = __webpack_public_path__ + "img/success.f042ad7b.svg";